import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error", "filename", "dropzone", "submit"]

  connect() {
    this.setupFileInput()
    this.setupDropzone()
    // Stelle sicher, dass der Submit-Button keine Animation hat
    if (this.hasSubmitTarget) {
      this.submitTarget.classList.remove('animate-pulse')
    }
  }

  setupFileInput() {
    const fileInput = this.inputTarget
    if (!fileInput) return

    fileInput.addEventListener('change', (event) => {
      this.handleFileSelect(event.target.files[0])
    })
  }

  setupDropzone() {
    const dropzone = this.dropzoneTarget
    if (!dropzone) return

    // Drag and Drop Events
    dropzone.addEventListener('dragover', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.add('border-blue-400', 'bg-blue-50')
    })

    dropzone.addEventListener('dragleave', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.remove('border-blue-400', 'bg-blue-50')
    })

    dropzone.addEventListener('drop', (e) => {
      e.preventDefault()
      e.stopPropagation()
      dropzone.classList.remove('border-blue-400', 'bg-blue-50')
      
      const files = e.dataTransfer.files
      if (files.length > 0) {
        const file = files[0]
        if (this.validateFile(file)) {
          // Erstelle ein FileList-Objekt und setze es auf den Input
          const dataTransfer = new DataTransfer()
          dataTransfer.items.add(file)
          this.inputTarget.files = dataTransfer.files
          this.handleFileSelect(file)
        }
      }
    })

    // Klick auf Dropzone öffnet File-Dialog
    dropzone.addEventListener('click', () => {
      this.inputTarget.click()
    })
  }

  handleFileSelect(file) {
    if (!file) {
      this.displayFilename('Keine Datei ausgewählt')
      this.disableSubmit()
      return
    }

    if (this.validateFile(file)) {
      this.displayFilename(file.name)
      this.enableSubmit()
    }
  }

  validateFile(file) {
    if (!file) return false

    // Prüfe Dateityp
    if (!file.name.toLowerCase().endsWith('.csv')) {
      this.showError('Bitte wählen Sie eine CSV-Datei aus.')
      return false
    }

    // Prüfe Dateigröße (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      this.showError('Die Datei ist zu groß. Maximale Größe: 10MB')
      return false
    }

    this.hideError()
    return true
  }

  displayFilename(filename) {
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = filename
    }
  }

  enableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove('opacity-50', 'cursor-not-allowed', 'animate-pulse')
    }
  }

  disableSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add('opacity-50', 'cursor-not-allowed')
      this.submitTarget.classList.remove('animate-pulse')
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message
      this.errorTarget.classList.remove('hidden')
    }
    this.disableSubmit()
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
  }

  display(event) {
    const file = event.target.files[0]
    this.handleFileSelect(file)
  }
}

